import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PropTypes from "prop-types";
import theme from 'src/theme';

function BasicMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(props.default.title);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (item) => {
    setAnchorEl(null);
    if(item && item.title){
      setSelected(item.title)
      props.onMenuSelect(item.id)
    }
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls="basic-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
        size="small"
        sx={{
          ...(props.shadow && {
            boxShadow: '0 0 4px rgba(0,0,0,0.20)',
          }),
          color: theme.palette.text.secondary,
          pl: 1
        }}
      >
        {selected}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={()=>handleClose()}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {
          props.list.map(menu => 
            <MenuItem key={menu.id} onClick={()=> handleClose(menu)}>{menu.title}</MenuItem>
          )
        }
      </Menu>
    </div>
  );
}

BasicMenu.propTypes = {
  onMenuSelect: PropTypes.func,
  list: PropTypes.array.isRequired,
  default: PropTypes.object.isRequired,
  shadow: PropTypes.bool
};
BasicMenu.defaultProps = {
  shadow: false
}
export default BasicMenu